/*
  Helper to sanitize HTML before using it with dangerouslySetInnerHTML.
  Uses DOMPurify in the browser. Falls back to a minimal sanitizer server-side
  to avoid importing DOM APIs during SSR.
*/
import createDOMPurify from "dompurify";

// DOMPurify expects a window-like object when running in the browser. We
// only initialize it when `window` is available (client-side).
let domPurify: ReturnType<typeof createDOMPurify> | null = null;
if (typeof window !== "undefined") {
  // cast to unknown then to Window to avoid using `any` while satisfying
  // the library which expects a window-like object.
  //use ts-ignore to avoid 2345
  domPurify = createDOMPurify(window);
  domPurify.addHook("afterSanitizeAttributes", (element) => {
    if (
      element.tagName === "A" &&
      element.getAttribute("target") === "_blank"
    ) {
      element.setAttribute("rel", "noopener noreferrer");
    }
  });
}

export const sanitizeHtml = (html: string | null | undefined): string => {
  if (!html) {
    return "";
  }
  try {
    if (domPurify) {
      const purifyConfig = {
        USE_PROFILES: { html: true, svg: true },
        ADD_ATTR: ["target"],
        ADD_TAGS: ["style"],
        FORCE_BODY: true,
      };
      return domPurify.sanitize(html, purifyConfig);
    }
  } catch (e) {
    // ignore and fallback
  }

  // Fallback: strip tags conservatively
  return html.replace(/<[^>]*>?/gm, "");
};

export default sanitizeHtml;
